import React from 'react'
import { PauseIcon, ResumeIcon } from '@mote/assets/icons'
import type { AudioState } from './AudioState'
import { CommonButton } from './Common'

export interface ResumePauseButtonProps {
  state: AudioState
  onResume: () => void
  onPause: () => void
}

export function ResumePauseButton(props: ResumePauseButtonProps): JSX.Element {
  const [icon, text, variant, ariaLabel] =
    props.state === 'playing'
      ? ([<PauseIcon />, 'Pause', 'secondary', 'pause'] as const)
      : ([<ResumeIcon />, 'Resume', 'inverted', 'resume'] as const)

  return (
    <CommonButton
      ariaLabel={ariaLabel}
      variant={variant}
      id={'resume-pause-button'}
      text={text}
      onClick={props.state === 'playing' ? props.onPause : props.onResume}
    >
      {icon}
    </CommonButton>
  )
}
